module.exports = __webpack_public_path__ + "assets/img/sport-packet.2608d56e.png";